module.exports = __webpack_public_path__ + "img/01.24793f53.jpg";